import { createSlice } from '@reduxjs/toolkit'
import {
  addCompany,
  companyChangeStatus,
  companyPagination,
  editCompany,
  filterCompanies,
  lastTenant,
  retrieveCompanies,
  retrieveCompaniesList,
  retrieveCompaniesModules,
  searchCompanies,
  sortCompanies,
  retrieveCompaniesFabsTenants,
} from './companiesThunk'

const defaultPageSize = 9
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: false,
  pageNumber: 0,
  pageSize: defaultPageSize,
  finalPage: false,
  summaries: {},
  activeSummary: defaultActiveSummary,
  sortBy: [],
  activeSort: {},
  activeSearch: '',
  lastTenant: null,
  value: [],
  companyModules: [],
  fabsTenants: [],
}

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  extraReducers: {
    [retrieveCompanies.fulfilled]: (state, { payload }) => {
      state.summaries = payload.metadata
      state.sortBy = payload.sort
      state.activeSort = payload?.sort[0]
      state.value = payload.companies
      state.pageNumber = 0
      state.finalPage = payload.companies.length < state.pageSize
      state.loading = false
    },
    [retrieveCompanies.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveCompanies.rejected]: (state) => {
      state.loading = false
    },
    [retrieveCompaniesList.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveCompaniesList.fulfilled]: (state, { payload }) => {
      state.loading = false

      state.value = payload
    },
    [companyPagination.fulfilled]: (state, { payload }) => {
      state.finalPage = payload.response.companies.length < state.pageSize
      state.pageNumber = payload.pageNumber
      state.value.push(...payload.response.companies)
      state.loading = false
    },
    [companyPagination.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [companyPagination.rejected]: (state) => {
      state.loading = false
    },
    [searchCompanies.fulfilled]: (state, { payload }) => {
      state.value = payload.response.companies
      state.summaries = payload.response.metadata
      state.activeSearch = payload.search
      state.pageNumber = 0
      state.finalPage = payload.response.companies.length < state.pageSize
      state.loading = false
    },
    [searchCompanies.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [searchCompanies.rejected]: (state) => {
      state.loading = false
    },
    [filterCompanies.fulfilled]: (state, { payload }) => {
      state.value = payload.response.companies
      state.activeSummary = payload.summary
      state.pageNumber = 0
      state.finalPage = payload.response.companies.length < state.pageSize
      state.loading = false
    },
    [filterCompanies.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [filterCompanies.rejected]: (state) => {
      state.loading = false
    },
    [sortCompanies.fulfilled]: (state, { payload }) => {
      state.value = payload.response.companies
      state.activeSort = payload.sort
      state.pageNumber = 0
      state.finalPage = payload.response.companies.length < state.pageSize
      state.loading = false
    },
    [sortCompanies.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [sortCompanies.rejected]: (state) => {
      state.loading = false
    },
    [addCompany.fulfilled]: (state) => {
      state.loading = false
    },
    [addCompany.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [addCompany.rejected]: (state) => {
      state.loading = false
    },
    [editCompany.fulfilled]: (state) => {
      state.loading = false
    },
    [editCompany.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [editCompany.rejected]: (state) => {
      state.loading = false
    },
    [companyChangeStatus.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [companyChangeStatus.fulfilled]: (state) => {
      state.pageNumber = 0
      state.loading = false
    },
    [companyChangeStatus.rejected]: (state) => {
      state.loading = false
    },
    [lastTenant.fulfilled]: (state, { payload }) => {
      state.lastTenant = payload
      state.loading = false
    },
    [lastTenant.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [lastTenant.rejected]: (state) => {
      state.loading = false
    },
    [retrieveCompaniesModules.fulfilled]: (state, { payload }) => {
      state.companyModules = payload
      state.loading = false
    },
    [retrieveCompaniesModules.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveCompaniesModules.rejected]: (state) => {
      state.loading = false
    },
    [retrieveCompaniesFabsTenants.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveCompaniesFabsTenants.rejected]: (state) => {
      state.loading = false
    },
    [retrieveCompaniesFabsTenants.fulfilled]: (state, { payload }) => {
      state.fabsTenants = payload
      state.loading = false
    },
  },
})

export const selectCompanies = ({ companies }) => companies

export default companiesSlice.reducer
